export default function () {
  return [

    , { key: 'ip' },
    , { key: 'alias' },
    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } }
  ]
}
